// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"4":"f70d2b1f","115":"6ec8b2a9","594":"91233cee","652":"03ea35c6","785":"201185f0","936":"317ad868"}[chunkId] + ".js";
};